import loading from "./loading";


export default {
  loading
}



// WEBPACK FOOTER //
// ./src/assets/script/directive/index.js